import React from "react";
import "./pages.css";
import "./pagesResponsiveStylesheet.css";
import PropTypes from "prop-types";
import {Articles} from "../Components/Contents/Articles";
import {GetBlogCard} from "./Blog";
import {Link} from "react-router-dom";
import ErrorPages from "../Components/EssentialPages/ErrorPages/ErrorPages";
import WhyIPAgentAI from "../Components/Blogs/WhyIPAgentAI";
import MetaData from "../Components/MetaData/MetaData";

export default class BlogDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            articles: Articles
        }
    }


    getMoreArticles = () => {
        let {articleID, setArticleID, scrollToTop} = this.props;
        let originalArticleList = JSON.parse(JSON.stringify(Articles));
        delete originalArticleList[articleID];
        let recommendedArticleList = []
        Object.keys(originalArticleList).slice(0, 3).map((res, index) =>
            recommendedArticleList.push(
                <GetBlogCard id={res} setArticleID={setArticleID} scrollToTop={scrollToTop}/>
            )
        )
        return (
            recommendedArticleList
        )
    }

    render() {
        let {articleID} = this.props;
        let info = Articles[articleID];
        return (
            info !== undefined && info !== null ?
                <div className="blog-detail-layout">
                    <MetaData keyword={"blogs"}/>
                    {
                        Object.keys(Articles).length > 1 &&
                        <div className="blog-detail-breadcrumb">
                            <Link to={`/blogs`}>
                                <div className="blog-detail-breadcrumb-link">
                                    Blogs
                                </div>
                            </Link>
                            >
                            <div className="blog-detail-breadcrumb-item">
                                {info.Title}
                            </div>
                        </div>
                    }

                    <div className="blog-detail-container">
                        <div className="blog-detail-blog-content">
                            <h2 className="blog-detail-blog-content-title">
                                {info.Title}
                            </h2>
                            <div className="blog-detail-info-row">
                                <div className="blog-detail-author-info">
                                    <div className="blog-detail-author-pic">
                                        <img src={info.AuthorInfo.Image}
                                             width={"100%"}
                                             alt={`${info.AuthorInfo.Name} Profile`}/>
                                    </div>
                                    <div className="blog-detail-author">

                                        {info.AuthorInfo.Name}
                                    </div>
                                </div>
                                <div className="blog-detail-date">
                                    <ul>
                                        <li>1 min Read</li>
                                        <li>{info.PublishedDate}</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="blog-detail-image-container">
                                <img src={info.Image} className="blog-detail-image"
                                     alt={info.Title} width={"100%"}/>
                            </div>
                            <div className="blog-detail-context-container">
                                {/*{info.Blog}*/}
                                <WhyIPAgentAI/>
                            </div>
                            <div className="blog-detail-author-division">

                                <div className="blog-detail-author-pp">
                                    <img src={info.AuthorInfo.Image}
                                         width={"100%"}
                                         alt={`${info.AuthorInfo.Name} Profile`}/>
                                </div>
                                <div className="blog-detail-author-profile">
                                    <div
                                        className="blog-detail-author-profile-detail-title">{info.AuthorInfo.Name}</div>
                                    <div className="blog-detail-author-profile-detail-info">
                                        {info.AuthorInfo.Title}, <a href={info.AuthorInfo.Company.Link}
                                                                    target={"_blank"}
                                                                    rel="noreferrer">{info.AuthorInfo.Company.Name}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            Object.keys(Articles).length > 1 &&
                            <div className="more-blog-content">
                                <div className="more-blog-content-title">
                                    More Articles
                                </div>
                                <div className="more-blog-content-body">
                                    <div className="more-blog-content-list">
                                        {this.getMoreArticles()}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                :
                <ErrorPages/>
        );
    }

}
BlogDetails.propTypes = {
    info: PropTypes.object.isRequired
}